import { render } from "./Settings-setting--notification-settings.vue?vue&type=template&id=78ca9928"
import script from "./Settings-setting--notification-settings.vue?vue&type=script&lang=ts"
export * from "./Settings-setting--notification-settings.vue?vue&type=script&lang=ts"
script.render = render

export default script